import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { assetsSchemaEntryPoint } from '@jira/spa-apps__servicedesk-cmdb-object-schema-v2/src/assetsSchemaEntryPoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { assetsSchemaRoute } from '@jira/router-routes__assets-app-routes/src/assetsSchemaRoute.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { ObjectSchemaV2 } from '@jira/router-routes__servicedesk-cmdb-entries/src/ui/object-schema/index.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

const assetsSchemaPageEntryPoint = createChromelessEntryPoint({
	main: assetsSchemaEntryPoint,
});

export const assetsSchemaRouteEntry: Route = createEntry(assetsSchemaRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: AssetsSpinner,
	// eslint-disable-next-line no-restricted-syntax
	component: ObjectSchemaV2,
	entryPoint: () => assetsSchemaPageEntryPoint,
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-object-schema',
	resources: getAssetsAppResources(),
	forPaint: [LazyAssetsLayout],
	perfMetricKey: 'service-management.insight-cmdb.load-schema-page',
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
